import { MapType } from '../typings/displayMap';
import { PredictorData, UpdateDataReach } from '../typings/predictor';

export const FETCH_PREDICTOR_EDITOR = 'FETCH_PREDICTOR_EDITOR';
export type FETCH_PREDICTOR_EDITOR = typeof FETCH_PREDICTOR_EDITOR;

export interface FetchPredictorEditorAction {
    type: FETCH_PREDICTOR_EDITOR;
    mapType: MapType;
}

export function fetchPredictorEditor(mapType: MapType): FetchPredictorEditorAction {
    return {
        type: FETCH_PREDICTOR_EDITOR,
        mapType
    };
}

export const UPDATE_PREDICTOR_EDITOR = 'UPDATE_PREDICTOR_EDITOR';
export type UPDATE_PREDICTOR_EDITOR = typeof UPDATE_PREDICTOR_EDITOR;

export interface UpdatePredictorEditorAction {
    type: UPDATE_PREDICTOR_EDITOR;
    data: UpdateDataReach;
}

export function updatePredictorReachEditor(data: UpdateDataReach): UpdatePredictorEditorAction {
    return {
        type: UPDATE_PREDICTOR_EDITOR,
        data
    };
}

export const SHOW_PREDICTOR_EDITOR_ERROR = 'SHOW_PREDICTOR_EDITOR_ERROR';
export type SHOW_PREDICTOR_EDITOR_ERROR = typeof SHOW_PREDICTOR_EDITOR_ERROR;

export interface ShowPredictorEditorErrorAction {
    type: SHOW_PREDICTOR_EDITOR_ERROR;
    errorMassage: string;
}

export function showPredictorEditorError(errorMassage: string): ShowPredictorEditorErrorAction {
    return {
        type: SHOW_PREDICTOR_EDITOR_ERROR,
        errorMassage
    };
}

export const INITIAL_PREDICTOR_EDITOR = 'INITIAL_PREDICTOR_EDITOR';
export type INITIAL_PREDICTOR_EDITOR = typeof INITIAL_PREDICTOR_EDITOR;

export interface InitialPredictorEditorAction {
    type: INITIAL_PREDICTOR_EDITOR;
    data: PredictorData;
}

export function initialPredictorReachEditor(data: PredictorData): InitialPredictorEditorAction {
    return {
        type: INITIAL_PREDICTOR_EDITOR,
        data
    };
}

export type PredictorEditorActions =
    | FetchPredictorEditorAction
    | UpdatePredictorEditorAction
    | ShowPredictorEditorErrorAction
    | InitialPredictorEditorAction;
